export enum RecurrenceStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DEFINITELY_INACTIVE = 'DEFINITELY INACTIVE'
}

export enum AuthorizationStatus {
  PENDING = 'PENDING',
  AUTHORIZED = 'AUTHORIZED',
  REJECTED = 'REJECTED',
  AUTHORIZATION_IN_PROGRESS = 'AUTHORIZATION IN PROGRESS'
}

export enum CancelationStatus {
  CANCELATION_IN_PROGRESS = 'CANCELATION IN PROGRESS',
  REFUND_IN_PROGRESS = 'REFUND IN PROGRESS',
  CANCELATED = 'CANCELATED',
  REFUNDED = 'REFUNDED'
}

export enum RecurrenceType {
  PROGRAMMED = 'PROGRAMMED'
}

export interface Recurrence {
  id: number
  externalId: string;
  status: RecurrenceStatus;
  type: RecurrenceType;
  amountPerQuote: string;
  quotes: number;
  sellerTaxId: string;
  benefit: string;
  buyerTaxId: string;
  buyerCbu: string;
  cancellationStatus: CancelationStatus;
  authorizationStatus: AuthorizationStatus;
  limitQuotes: number;
  concept: string;
  details: string;
  reference: string;
  createdAt: Date;
  validForRefund?: boolean;
  paidQuotes?: number;
  hasQuoteInProgress?: boolean;
}

export enum DebinInternalStatus {
  PENDING = 1,
  COMPLETED = 2,
  REJECTED = 3,
  CANCELED = 4,
}

export interface DebinMovement {
  id: number
  activityData: string
  date: Date
  amount: string
  concept: string
  internalStatus: DebinInternalStatus
}

export interface DebinState {
  isLoading: boolean
  isDebinMovementsLoading: boolean
  isError: boolean
  recurrences: Recurrence[]
  debinMovements: DebinMovement[]
}

export enum DebinActionTypes {
  GET_RECURRENCES_PENDING = '@DEBIN:GET_RECURRENCES_PENDING',
  GET_RECURRENCES_REJECTED = '@DEBIN:GET_RECURRENCES_REJECTED',
  GET_RECURRENCES_FULFILLED = '@DEBIN:GET_RECURRENCES_FULFILLED',
  CONFIRM_RECURRENCE_PENDING = '@DEBIN:CONFIRM_RECURRENCE_PENDING',
  CONFIRM_RECURRENCE_REJECTED = '@DEBIN:CONFIRM_RECURRENCE_REJECTED',
  CONFIRM_RECURRENCE_FULFILLED = '@DEBIN:CONFIRM_RECURRENCE_FULFILLED',
  CANCEL_RECURRENCE_PENDING = '@DEBIN:CANCEL_RECURRENCE_PENDING',
  CANCEL_RECURRENCE_REJECTED = '@DEBIN:CANCEL_RECURRENCE_REJECTED',
  CANCEL_RECURRENCE_FULFILLED = '@DEBIN:CANCEL_RECURRENCE_FULFILLED',
  GET_DEBIN_MOVEMENTS_PENDING = '@DEBIN:GET_DEBIN_MOVEMENTS_PENDING',
  GET_DEBIN_MOVEMENTS_FULFILLED = '@DEBIN:GET_DEBIN_MOVEMENTS_FULFILLED',
  GET_DEBIN_MOVEMENTS_REJECTED = '@DEBIN:GET_DEBIN_MOVEMENTS_REJECTED'
}
